import { Document, Page, Text, pdf } from '@react-pdf/renderer';

export function RecoveryCodesPDF({
  recoveryCodes,
}: {
  recoveryCodes: string[];
}) {
  return (
    <Document producer="Peopleware" creator="Peopleware">
      <Page size="A4" style={{ padding: '30pt' }}>
        {recoveryCodes.map((code) => (
          <Text key={code}>{code}</Text>
        ))}
      </Page>
    </Document>
  );
}

export async function downloadBackupCodesPDF(recoveryCodes: string[]) {
  const blob = await pdf(
    <RecoveryCodesPDF recoveryCodes={recoveryCodes} />,
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'peopleware-backup-codes.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
